// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__-nLdj","messages":"Chat_messages__3WdLJ","dateDivider":"Chat_dateDivider__awzgU"};